export default {
  template: `
    <div class="m-auto d-flex form-container">
    <div>
      <nk-input v-model="currentValue" @update:modelValue="onInputBoxChanged" />
    </div>
    <div class="mr-2 d-flex" style="">
      <a class="input-button m-auto" style="" data-clear>
        <i class="fa fa-times " style="cursor:pointer" v-on:click="removeFilter"></i>
      </a>
    </div>
    </div>
  `,
  data: function () {
    return {
      currentValue: null,
    }
  },
  methods: {
    removeFilter() {
      this.currentValue = ''
      this.onInputBoxChanged()
    },
    onInputBoxChanged() {
      const valueSetter = () => {
        this.params.parentFilterInstance((instance) => {
          this.timeout && clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            instance.myMethodForTakingValueFromFloatingFilter(this.currentValue === '' ? null : this.currentValue)
          }, this.params.filterParams.debounceMs)
        })
      }

      valueSetter()

    },

    onParentModelChanged(parentModel) {
      // console.log('floating',parentModel)
      // When the filter is empty we will receive a null value here
      if (parentModel == null) {
        this.currentValue = ''
      } else {
        this.currentValue = parentModel.filter
      }
    },
  },
}
